import { Radius } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
const Select = dynamic(() => import('react-select'), { ssr: false });


export default function DepartmentSelect({ onChange, style }) {
    const [departments, setDepartments] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                //const response = await fetch("/api/departments");
                const response = await fetch("/colombia.json");
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                // Sort departments alphabetically by name
                //const sortedCities = data.sort((a, b) => a.name.localeCompare(b.name));
                setDepartments(data)
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };

        fetchDepartments();
    }, []);

    const customStyle = {
        dropdownIndicator: (base, state) => ({
            ...base,
            transition: 'all .2s ease',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null
        }),
        control: (base, state) => ({
            ...base,
            height: style ? style.height : "45px",
            borderColor: style ? style.borderColor : "#9EA3A5",
            boxShadow: style ? "none" : "",
            borderRadius: style ? style.rounded : "none",
            '&:hover': {
                borderColor: style ? "none" : "", // Remove hover border
            },
        })
        // Add more styles as needed
    };


    // Map departments to options after sorting
    const options = departments.map(department => ({
        value: department.departamento,
        label: department.departamento,
        id: department.id,
    }));



    return (
        <div id="Ciudad" className="mb-4">
            <div className="relative w-full border-none">
                <Select
                    value={selectedOption}
                    onChange={option => {
                        setSelectedOption(option);
                        onChange(option.value, option.id); // Call the onChange handler with the selected value
                    }}
                    options={options}
                    styles={customStyle}
                    placeholder="Seleccione un departamento"
                    required
                />
            </div>
        </div>
    );
}
